import React from 'react'
import Game from '../Game/Game'

const App = () => (
  <div>
    <Game />
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js